export enum RoutingArrangmentIndicator {
  /** No routing arrangement in place */
  NoRoutingArrangmentInPlace = 0,
  /** Routing arrangement in place */
  RoutingArrangementInPlace = 1,
}
